import url from './url.js'
import {combineReducers} from 'redux'

const rootReducer = combineReducers({
  url
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js